"use strict";

import "regenerator-runtime/runtime.js";
import "cookie-store";

import { initDayJs } from "./utility/dayjs";
import { Promo } from "./checkout/promo";
import { createStore } from "redux";
import { reducer, mockStore } from "./checkout/store";
import { OrderSummary } from "./checkout/order-summary";
import { DeliveryOptions } from "./checkout/delivery-options";
import { GiftVoucher } from "./checkout/gift-voucher";
import { Donation } from "./checkout/donation";
import { Reward4Racing } from "./checkout/reward-4-racing";
import { autoTabFields } from "./utility/autoTabFields";
import { initCopyTextContents } from "./utility/copyTextContent";
import { initStripePaymentElement } from "../components/ticketing/checkout";
import { initEmailJump } from "../components/ticketing/checkout";
import { initTicketing } from "../components/ticketing";
import { toggleCssClass } from "./utility/toggleCssClass";
import { toggleState } from "./utility/toggleState";
import { togglePasswordVisibility } from "../components/form-components/inputPassword/inputPassword";

import initTooltips from "../components/tooltip/tooltip";
// // TODO: Mock to be removed when we have a real store
const store = createStore(reducer, mockStore);

initDayJs();

window.addEventListener("load", () => {
  initTicketing();
  initStripePaymentElement();
  autoTabFields("[data-auto-tab-fields]");
  initCopyTextContents();
  togglePasswordVisibility();
  toggleState("[data-target-account-details]", "targetAccountDetails", "active");

  initTooltips();
  initEmailJump();

  new Promo("[data-promo]", store);
  new OrderSummary("[data-order-summary]", store);
  new DeliveryOptions("[data-delivery-options]", store);
  new GiftVoucher("[data-gift-voucher]", store);
  new Donation("[data-donation]", store);
  new Reward4Racing("[data-rewards-racing]", store);
});

// Toggler for user account navigation on mobile
toggleState("[data-target]", "target", "active");
toggleCssClass("[data-user-navigation]", "active");
